import { useDispatch, useSelector } from 'react-redux';
import {
  getHubDetailAudit,
  getIdDetailAudit,
} from '../../../../../../store/audit/detailAudit';
import { useState } from 'react';
import { getMissingQrCode } from '../../../../../../api/audit';
import { useEffect } from 'react';
import {
  Box,
  Checkbox,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
  useTheme,
} from '@mui/material';
import {
  ArrowBackIosIcon,
  ArrowForwardIosIcon,
  ArrowRightAltIcon,
  ExportIcon,
  FilterAltIcon,
  SearchIcon,
  SyncAltIcon,
} from '../../../../../../assets/Icons';
import CustomCard from '../../../../../../components/shared/CustomCard';
import { useRef } from 'react';
import debounce from 'lodash.debounce';
import QRCode from 'react-qr-code';
import {
  changeIdAuditAdjustment,
  changeLocationHub,
  goToAdjustMissingQr,
} from '../../../../../../store/adjustment/addMissingQrAdjustment';
import { changePageAdjustment } from '../../../../../../store/Routing/addjustment';

const CustomTableCells = styled(TableCell)({
  color: '#000000',
  fontWeight: 500,
  fontSize: '12px',
  textTransform: 'capitalize',
});

const TableListMissingQrCode = ({ setValue }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const idAudit = useSelector(getIdDetailAudit);
  const [missingQr, setMissingQr] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [select, setSelect] = useState(false);
  const [adjusData, setAdjustData] = useState([]);
  const location = useSelector(getHubDetailAudit);

  // !search
  const [search, setSearch] = useState('');
  const [purchaseKeyword, setPurchaseKeyword] = useState('');

  // ! table
  const [pages, setPages] = useState();
  const rowPerPageValues = [5, 10, 15, 20, 25];
  const [rowPerPage, setRowPerPage] = useState(rowPerPageValues[0]);
  const [currentPageTable, setCurrentPageTable] = useState(1);

  // ! sorting table
  const [sortTable, setSortTable] = useState('');
  const [asc, setAsc] = useState('asc');
  const [sortAscTable, setSortAscTable] = useState(true);

  const debounceOnChange = useRef(
    debounce((value) => {
      setPurchaseKeyword(value);
    }, 1000)
  ).current;

  // ! ------------- Handler ----------------------

  // ! pagination
  const handleRowPerPage = (e) => {
    setRowPerPage(e.target.value);
    setCurrentPageTable(1);
  };
  const handleBackArrow = () => {
    setCurrentPageTable(
      currentPageTable <= 1 ? currentPageTable : currentPageTable - 1
    );
  };
  const handleForwardArrow = () => {
    setCurrentPageTable(
      currentPageTable >= Math.ceil(pages?.total / rowPerPage)
        ? currentPageTable
        : currentPageTable + 1
    );
  };
  const handleInputCurrentPage = (event) => {
    if (event.target.value >= Math.ceil(pages?.total / rowPerPage)) {
      setCurrentPageTable(Math.ceil(pages?.total / rowPerPage));
    } else if (event.target.value <= 1) {
      setCurrentPageTable(1);
    } else {
      setCurrentPageTable(event.target.value);
    }
  };

  // ! select & adjust
  const handleCancelSelect = () => {
    setSelect(false);
    setAdjustData([]);
  };

  const handleToAdjust = () => {
    dispatch(goToAdjustMissingQr(adjusData));
    setValue(7);
    dispatch(changePageAdjustment('addMissingQrAdjustment'));
    dispatch(changeIdAuditAdjustment(idAudit));
    dispatch(changeLocationHub(location));
  };

  // ! --------------------------------- API --------------------

  const fetchMissingQrCode = async (id) => {
    setIsLoading(true);
    try {
      const {
        data: { data },
      } = await getMissingQrCode(id);
      setMissingQr(data?.missing);
      setPages(data?.pageInfo);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMissingQrCode(idAudit);
  }, [idAudit]);

  //! -------------- TOOLBAR -------------------
  const [isFilter, setIsFilter] = useState(false);
  const toolbar = (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        flexDirection: 'row-reverse',
        alignItems: 'center',
      }}
    >
      {/* export */}
      <CustomCard
        sx={{
          p: '10px 20px',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
        }}
        onClick={() => setIsFilter(!isFilter)}
      >
        <ExportIcon sx={{ fontSize: '20px' }} />
        <Typography
          sx={{ fontSize: '14px', fontWeight: 500, color: '#000000' }}
        >
          Export
        </Typography>
      </CustomCard>

      {select ? (
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Box onClick={handleCancelSelect}>
            <Typography
              sx={{
                color: '#F33A3A',
                fontWeight: 600,
                fontSize: '14px',
                cursor: 'pointer',
              }}
            >
              Cancel
            </Typography>
          </Box>
          <Box onClick={handleToAdjust}>
            <Typography
              sx={{
                background: '#51B15C',
                color: '#FFFFFF',
                fontWeight: 600,
                fontSize: '14px',
                cursor: 'pointer',
                borderRadius: '8px',
                padding: '10px 15px',
              }}
            >
              Adjust
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box onClick={() => setSelect(true)}>
          <Typography
            sx={{
              color: '#51B15C',
              fontWeight: 600,
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            Select
          </Typography>
        </Box>
      )}
    </Box>
  );

  const handleChange = (event, item, id) => {
    if (adjusData.filter((val) => val.auditQrId === id).length === 0) {
      setAdjustData((prev) => [...prev, item]);
    } else {
      setAdjustData(adjusData.filter((val) => val.auditQrId !== id));
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* search */}
      <Grid container columnSpacing={4} alignItems="center">
        <Grid item xs>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>
              Missing QR Code
            </Typography>
            <TextField
              placeholder={'Search'}
              size="small"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                debounceOnChange(e.target.value);
              }}
              sx={{
                width: '250px',
                '& .MuiOutlinedInput-root': {
                  paddingLeft: '6px',
                  fontSize: '0.875rem',
                },
                bgcolor: '#FAFAFA',
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ width: '18px' }} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>

        <Grid item xs="auto">
          {toolbar}
        </Grid>
      </Grid>

      {/* fetch ddata llist */}
      <Table
        sx={{
          marginTop: '12px',
          mb: 5,
        }}
      >
        <TableHead>
          <TableRow
            sx={{
              background: '#FAFAFA',
              fontWeight: 600,
            }}
          >
            <CustomTableCells>{select ? '' : 'No'}</CustomTableCells>
            <CustomTableCells>Qr Code</CustomTableCells>
            <CustomTableCells>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setSortTable('sortProduct');
                  setSortAscTable(!sortAscTable);
                  if (sortAscTable === true) {
                    setAsc('asc');
                  } else {
                    setAsc('desc');
                  }
                }}
              >
                <Typography
                  sx={{ fontSize: '12px', fontWeight: '500', mr: '2px' }}
                >
                  Product
                </Typography>
                {sortTable === 'sortProduct' ? (
                  sortAscTable ? (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(90deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  ) : (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(270deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  )
                ) : (
                  <SyncAltIcon
                    sx={{
                      fontSize: '12px',
                      transform: 'rotate(90deg)',
                      color: '#9E9D9D',
                    }}
                  />
                )}
              </Box>
            </CustomTableCells>
            <CustomTableCells>Hub</CustomTableCells>
            <CustomTableCells>Rack</CustomTableCells>
            <CustomTableCells>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setSortTable('sortQty');
                  setSortAscTable(!sortAscTable);
                  if (sortAscTable === true) {
                    setAsc('asc');
                  } else {
                    setAsc('desc');
                  }
                }}
              >
                <Typography
                  sx={{ fontSize: '12px', fontWeight: '500', mr: '2px' }}
                >
                  Qty
                </Typography>
                {sortTable === 'sortQty' ? (
                  sortAscTable ? (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(90deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  ) : (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(270deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  )
                ) : (
                  <SyncAltIcon
                    sx={{
                      fontSize: '12px',
                      transform: 'rotate(90deg)',
                      color: '#9E9D9D',
                    }}
                  />
                )}
              </Box>
            </CustomTableCells>
            <CustomTableCells>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setSortTable('sortCogs');
                  setSortAscTable(!sortAscTable);
                  if (sortAscTable === true) {
                    setAsc('asc');
                  } else {
                    setAsc('desc');
                  }
                }}
              >
                <Typography
                  sx={{ fontSize: '12px', fontWeight: '500', mr: '2px' }}
                >
                  COGS
                </Typography>
                {sortTable === 'sortCogs' ? (
                  sortAscTable ? (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(90deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  ) : (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(270deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  )
                ) : (
                  <SyncAltIcon
                    sx={{
                      fontSize: '12px',
                      transform: 'rotate(90deg)',
                      color: '#9E9D9D',
                    }}
                  />
                )}
              </Box>
            </CustomTableCells>
          </TableRow>
        </TableHead>
        {!isLoading && (
          <TableBody>
            {missingQr?.map((item, index) => (
              <TableRow
                sx={{ cursor: 'pointer' }}
                // onClick={() => {
                // }}
              >
                {select ? (
                  <CustomTableCells>
                    <Checkbox
                      checked={
                        adjusData.filter(
                          (val) => val.auditQrId === item.auditQrId
                        ).length !== 0
                      }
                      onChange={(event) => {
                        handleChange(event, item, item?.auditQrId);
                      }}
                    />
                  </CustomTableCells>
                ) : (
                  <CustomTableCells>
                    {(currentPageTable - 1) * rowPerPage + (index + 1)}
                  </CustomTableCells>
                )}

                <CustomTableCells>
                  <QRCode
                    size={48}
                    style={{
                      height: '48px',
                      maxWidth: '48px',
                      width: '100%',
                      borderRadius: '4px',
                    }}
                    value={item?.encript}
                    viewBox={`0 0 48 48`}
                  />
                </CustomTableCells>
                <CustomTableCells>{item?.namaProduk}</CustomTableCells>
                <CustomTableCells>{item?.hub}</CustomTableCells>
                <CustomTableCells>{item?.rackName}</CustomTableCells>
                <CustomTableCells>
                  {item?.qty} {item?.systemUnit}
                </CustomTableCells>
                <CustomTableCells>{item?.cogs}</CustomTableCells>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>

      {!isLoading && missingQr.length === 0 && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <Typography sx={{ color: '#F33A3A' }}>No data found</Typography>
        </Box>
      )}

      {isLoading && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {/* pagination */}
      <Grid
        container
        direction="row"
        coloumn={12}
        alignItems="center"
        sx={{ mt: '30px' }}
      >
        <Grid item xs={6} sx={{ fontSize: '14px', fontWeight: '500' }}>
          Showing{' '}
          {pages?.currentPage ||
            0 * pages?.perPage ||
            0 - (pages?.perPage || 0 - 1)}{' '}
          to{' '}
          {pages?.currentPage || 0 * pages?.perPage || 0 >= pages?.total || 0
            ? pages?.total || 0
            : pages?.currentPage || 0 * pages?.perPage || 0}{' '}
          of {pages?.total || 0} entries
        </Grid>
        <Grid
          container
          item
          direction="row"
          xs={6}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item sx={{ fontSize: '14px', fontWeight: '500' }}>
            Rows Per Page :
            <Select
              value={rowPerPage}
              variant="filled"
              onChange={handleRowPerPage}
              sx={{
                fontSize: '14px',
                lineHeight: '-1px',
                '.MuiFilledInput-input': {
                  paddingTop: '7.5px',
                  paddingBottom: '7.5px',
                  paddingLeft: '10px',
                  paddingRight: '0',
                  borderRadius: '5px',
                },
                '&:before': {
                  borderRadius: '5px',
                  borderBottom: 0,
                },
                '&:after': {
                  borderRadius: '5px',
                  borderBottom: 0,
                },
                borderRadius: '5px',
                marginLeft: '8px',
              }}
            >
              {rowPerPageValues?.map((rowPerPageValue, index) => (
                <MenuItem value={rowPerPageValue} key={index}>
                  {rowPerPageValue}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item sx={{ ml: '35px' }}>
            <Box sx={{ display: 'inline', mr: '10px' }}>
              <IconButton sx={{ p: 0 }} onClick={handleBackArrow}>
                <ArrowBackIosIcon sx={{ color: '#323232', width: '16px' }} />
              </IconButton>
            </Box>
            <Box sx={{ display: 'inline', mr: '20px' }}>
              <OutlinedInput
                variant="outlined"
                type="number"
                value={currentPageTable}
                onChange={handleInputCurrentPage}
                sx={{
                  border: '1px solid #9E9D9D',
                  width: '36px',
                  borderRadius: '5px',
                  textAlign: 'center',
                  '& .MuiOutlinedInput-input': {
                    padding: '5px 8px 5px 8px',
                    fontSize: '0.875rem',
                    boxShadow: 'none',
                    textAlign: 'center',
                    fontWeight: 600,
                    width: '25px',
                  },
                  '&:before': {
                    borderRadius: '5px',
                    borderBottom: 0,
                  },
                  '&:after': {
                    borderRadius: '5px',
                    borderBottom: 0,
                  },
                  '&.Mui-focused': {
                    '& .MuiOutlinedInput-notchedOutline': {
                      boxShadow: 'none',
                    },
                  },
                }}
              />
            </Box>
            <Box
              sx={{
                display: 'inline',
                fontWeight: '600',
                fontSize: '14px',
                color: '#9E9D9D',
              }}
            >
              of {Math.ceil(pages?.total || 0 / pages?.perPage || 0)}
            </Box>
            <Box sx={{ display: 'inline', ml: '10px' }}>
              <IconButton sx={{ p: 0 }} onClick={handleForwardArrow}>
                <ArrowForwardIosIcon sx={{ color: '#323232', width: '16px' }} />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default TableListMissingQrCode;
